import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import MileageBuilder from './MileageBuilder';

// Actions
import { setMileage, selectMileage } from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import {
  getMileage,
  getEngineSize,
  getModel
} from 'store/reducers/appointment/selectors';
import { getMileageUnit } from 'store/reducers/dealerSettings/selectors';
import { hasIDK } from 'store/reducers/trims/selectors';
import { getIsQuoteAppt } from 'store/reducers/quoteAppt/selectors';

const mapStateToProps = state => ({
  hasIDK: hasIDK(state),
  mileage: getMileage(state),
  mileageUnit: getMileageUnit(state),
  engineSize: getEngineSize(state),
  model: getModel(state),
  isQuoteAppt: getIsQuoteAppt(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setMileage,
      selectMileage,
      gtmUserEvent
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(MileageBuilder);



// WEBPACK FOOTER //
// ./src/components/molecules/MileageBuilder/MileageBuilderContainer.js